module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pending_payment":"Pending payment!","text":"Failure to pay on time can result in account suspension or termination"},"id":{"pending_payment":"Pembayaran Tertunda!","text":"Kegagalan membayar tepat waktu dapat mengakibatkan penangguhan atau penghentian akun"}}')
  delete Component.options._Ctor
}
